export default __webpack_public_path__ + "static/Brush-7d55e3a74ad347c3ef87078eca31d887.png";